<template>
  <div class="potential" :class="{lan_En: lan != 'zh'}">
    <div class="potential_title">{{ $t('home.potential.title') }}</div>
    <div class="potential_cont show">
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img1" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text1_1') }}</div>
          <div class="coinList">
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/HNT.png" alt="">
              <div class="coin_text1">Helium</div>
              <div class="coin_text">+2300%</div>
            </div>
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/RNDR.png" alt="">
              <div class="coin_text1">Render</div>
              <div class="coin_text">+3700%</div>
            </div>
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/AKT.png" alt="">
              <div class="coin_text1">Akash</div>
              <div class="coin_text">+900%</div>
            </div>
          </div>
          <!-- <div class="text2">
            {{ $t('home.potential.text1_2') }} 
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_3') }} 
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_4') }}
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_5') }}
          </div> -->
        </div>
      </div>
      <div class="potential_li">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text2') }}</div>
        </div>
        <img class="li_img" v-lazy="pot_img2" alt="">
      </div>
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img3" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text3') }}</div>
        </div>
      </div>
      <div class="potential_li">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text4') }}</div>
        </div>
        <img class="li_img" v-lazy="pot_img4" alt="">
      </div>
    </div>
    <div class="potential_cont hide">
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img1" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text1_1') }}</div>
          <div class="coinList">
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/HNT.png" alt="">
              <div class="coin_text1">Helium</div>
              <div class="coin_text">+2300%</div>
            </div>
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/RNDR.png" alt="">
              <div class="coin_text1">Render</div>
              <div class="coin_text">+3700%</div>
            </div>
            <div class="coin_li">
              <img class="coin_img" src="../assets/pot/AKT.png" alt="">
              <div class="coin_text1">Akash</div>
              <div class="coin_text">+900%</div>
            </div>
          </div>
          <!-- <div class="text2">
            {{ $t('home.potential.text1_2') }} 
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_3') }} 
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_4') }}
            <img class="icon" src="../assets/pot/pot_icon.png" alt="">
            {{ $t('home.potential.text1_5') }}
          </div> -->
        </div>
      </div>
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img2" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text2') }}</div>
        </div>
      </div>
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img3" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text3') }}</div>
        </div>
      </div>
      <div class="potential_li">
        <img class="li_img" v-lazy="pot_img4" alt="">
        <div class="li_content">
          <div class="text1">{{ $t('home.potential.text4') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  
  import pot_img1 from "@/assets/pot/pot_img1.png"
  import pot_img2 from "@/assets/pot/pot_img2.png"
  import pot_img3 from "@/assets/pot/pot_img3.png"
  import pot_img4 from "@/assets/pot/pot_img4.png"
  export default defineComponent({
    name: 'potential',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      return {
        lan,
        pot_img1,
        pot_img2,
        pot_img3,
        pot_img4
      };
    }
  })
</script>

<style scoped lang="scss">
.potential {
  width: 1200px;
  padding: 30px 40px;
  border-radius: 20px;
  margin: 60px auto;
  box-sizing: border-box;
  background: linear-gradient(86.6deg, rgba(47, 67, 55, 0.612) 5.45%, rgba(46, 81, 60, 0.27) 97.19%);
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .potential_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 24px;
    letter-spacing: 0.05em;
  }
  .potential_cont {
    width: 100%;
    .potential_li {
      width: 100%;
      display: flex;
      border-radius: 20px;
      align-items: center;
      margin-bottom: 12px;
      background: rgba(152, 255, 194, 0.16);
      &:last-child {
        margin-bottom: 0;
      }
      .li_img {
        width: 560px;
        height: 230px;
      }
      .li_content {
        flex: 1;
        height: 230px;
        display: flex;
        padding: 0 60px;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
        .text1 {
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 38px;
          letter-spacing: 0.08em;
        }
        .text2 {
          display: flex;
          font-size: 15px;
          font-weight: 700;
          line-height: 20px;
          letter-spacing: 0em;
          align-items: center;
          justify-content: center;
          color: rgba(255, 255, 255, 0.6);
          .icon {
            width: 20px;
            height: 16px;
            margin: 0 16px;
            display: inline-block;
          }
        }
        .coinList {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          .coin_li {
            display: flex;
            align-items: center;
            flex-direction: column;
            .coin_img {
              height: 50px;
            }
            .coin_text1 {
              color: #fff;
              margin: 2px 0;
              font-size: 14px;
              text-align: center;
            }
            .coin_text {
              display: flex;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: 0em;
              align-items: center;
              justify-content: center;
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
      }
    }
  }
}
.lan_En.potential {
  .potential_cont {
    .potential_li {
      .li_content {
        .text1 {
          line-height: 24px;
        }
      }
    }
  }
}


@media screen and (max-width: 1200px) {
  .potential {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .potential_cont {
      .potential_li {
        overflow: hidden;
        flex-direction: column;
        .li_img {
          width: 100%;
          height: unset;
        }
        .li_content {
          padding: 26px 10px;
          .coinList {
            margin-top: 20px;
          }
        }
      }
      
    }
  }
}
</style>